import { NPSWorkflowState } from './useNPSFormWorkflowCoordinator'

export const SCORE_LOW = 1
export const SCORE_HIGH = 10
export const MAX_FEEDBACK_LENGTH = 1200

export const NPS_FORM = '478b48f0-2834-11f0-9150-c6f43f22a076'

export const FieldIds = {
    SCORE: 'GoRv29A94Yzxbox2WZ2xALWp0',
    SCORE_RATIONALE: 'ZAyAkJ33BGyXqMmVXYAAzEpAn',

    AREAS_EXCEEDING_EXPECTATION: 'yNaJM1pD4VyORMqEG9MoZbKKG',
    PRIMARY_VALUE: 'ZAJ0NeoX79pv5pY5Rp7Lxd0jx',
    AREAS_FALLING_SHORT: 'mvE4LZX5nY2yVE72zD3GOaMZO',

    CUSTOMER_SERVICE_SATISFACTION: '4GxdAEqqwMjk2pV3zvwdzB11',
    MESSAGING_SATISFACTION: 'ZZaLNlLEeXq69v7zjxKnElBY',
    SCHEDULING_SATISFACTION: 'm3rp2zRAqvbMy2YZyvG3rAOd',
    CLIENT_EXPERIENCE_SATISFACTION: '4kG9KWbV1ZeydW4KKzAo1doM',
    MAKE_MONEY_SATISFACTION: 'pxApkWWAr0de50wYEyGnDJy2X',

    MOST_USEFUL_FEATURES: 'y5WBW2EXaNmLBjkMVJ1Xzw9rx',
    LEAST_USEFUL_FEATURES: 'm423nLZl94x6J3R0eZK6L967',
    IMPROVEMENT_AREAS: '4DVXaErda9KyLm6L0wDvx7MJY',
    FINAL_THOUGHTS: 'mV3MLz33Jy9BrxbVo6EW7l3q0',

    CONFIRM_CONTINUE: 'aVm0lOzj4ZlDmEa5wd6vXvGB3',
    CONFIRM_COMPLETE: '36Dkv2EYXnARER1neobJBK2x',
} as const

const STEP_IDS = [
    'SCORE',
    'SCORE_RATIONALE',
    'CONFIRM_CONTINUE',
    'SATISFACTION_RATINGS',
    'FEATURE_AND_VALUE_FEEDBACK',
    'ADDITIONAL_FEEDBACK',
    'CONFIRM_COMPLETE',
] as const

export const StepIds = STEP_IDS.reduce((acc: any, stepId) => {
    acc[stepId] = stepId

    return acc
}, {}) as { [V in (typeof STEP_IDS)[number]]: V }

export type NPSFieldId = (typeof FieldIds)[keyof typeof FieldIds]

export type NPSStepId = (typeof StepIds)[keyof typeof StepIds]

export type NPSStepProps = NPSWorkflowState<NPSStepId>
